import {
  AUTH_START,
  AUTH_SUCCESS,
  AUTH_LOGOUT,
  AUTH_FAIL,
  REGISTER_SUCCESS
} from "../actions/auth";

const authReducer = (state = {}, action) => {
  switch (action.type) {
    case AUTH_START:
      return (state = { ...state, isFetching: true });
      break;
    case AUTH_SUCCESS:
      return (state = {
        ...state,
        token: action.token,
        expirationDate: action.expirationDate,
        isAuthenticated: true,
        error: null
      });
      break;
    case REGISTER_SUCCESS:
      return (state = {
        ...state,
        userId: action.userId,
        isRegistered: true,
        error: null
      });
      break;
    case AUTH_LOGOUT:
      return (state = {
        ...state,
        userId: null,
        token: null,
        expirationDate: null,
        isRegistered: false,
        error: null
      });
      break;
    case AUTH_FAIL:
      return (state = {
        ...state,
        userId: null,
        isRegistered: false,
        token: null,
        expirationDate: null,
        isAuthenticated: false,
        error: action.error
      });
    default:
      return state;
  }
};

export default authReducer;
